module.exports = __webpack_public_path__ + "static/media/soviet_hq_120.03053461.png";